import React from 'react';
import PropTypes from 'prop-types';
import { AppProvider, Page, Frame, Toast, Card, FormLayout, Select, Button, ExceptionList } from '@shopify/polaris';
import translations from '@shopify/polaris/locales/es.json';
import { PolarisFormProvider } from '@container';
import DispatchControlForm from '@presentational/dispatch_control/DispatchControlForm';

import axios from '@utils/axios';

const propTypes = {
  courierOptions: PropTypes.array.isRequired,
  submitURL: PropTypes.string.isRequired,
}

class DispatchControlFormWrapper extends React.Component {

  constructor(props) {
    super(props)

    let data = {...props.dispatch_control, dispatch_order: props.dispatch_order}
    this.state = {
      defaultValues: data,
      couriers: props.couriers,
      ids: [],
      queryOrdersUrl: props.queryOrdersUrl,
      loading: false,
      orders: [],
      courier_id: 0,
      errors: {},
      showToast: false,
      toastContent: ""
    }

  }

  handleSubmit = async () => {
    const { orders, courier_id } = this.state;
    const { submitURL } = this.props;
    this.setState({loading: true})

    try {
      let response = await axios.post(submitURL, {
        courier_id: courier_id,
        dispatch_orders_attributes: orders
      })
      if (response.data.success) {
        window.location = response.data.redirectUrl;
      }
      else{
        console.log("Non success", response);
        this.setState({errors: response.data.errors})
        this.postToast(I18n.t("app.messages.record_errors") );
      }
    } catch (error) {
      this.postToast(I18n.t('dispatchControl.errors.error'));

      console.log(error);

    }

    this.setState({loading: false})

  }

  handleOrderIDChange = (ids) => {
    this.setState({ids})
  }

  queryOrders = async () => {
    const { ids, queryOrdersUrl } = this.state;
    this.setState({ loading: true })

    if(ids.length == 0){
      this.postToast( I18n.t("dispatchControl.errors.id"))
      this.setState({ loading: false })
      return false;
    }

    try {
      let response = await axios.post(queryOrdersUrl, {ids})
      if (response.data.success) {
        this.setState({ orders: response.data.orders })
          this.state.orders.length == 0 ? this.postToast(I18n.t('dispatchControl.errors.noFound')): null
      }

    } catch (error) {
      {this.postToast(I18n.t('dispatchControl.errors.error'))}
    }

    await this.setState({ loading: false })
  }

  handleCourierChange = (value, name) => {
    this.setState({courier_id: parseInt(value)})
  }


  postToast = (message) => {
    this.setState({
      showToast: true,
      toastContent: message
    });
  }

  closeToast = () => {
    this.setState({
      showToast: false,
    })
  }

  render() {
    let { defaultValues, courier_id, ids, loading, orders, showToast, toastContent, errors } = this.state;
    console.log("DCFW", this.state)
    return (
      <AppProvider i18n={translations}>
        <Frame>
          <Page
            title={ `${I18n.t("actions.new")} ${I18n.t("activerecord.models.dispatch_control.one")}` }
            breadcrumbs={[{content: I18n.t("actions.back"), url: '/admin/dispatch_controls'}]}>
            <DispatchControlForm
              handleOrderIDChange={ this.handleOrderIDChange }
              handleCourierChange={ this.handleCourierChange }
              queryOrders={ this.queryOrders }
              courierOptions = { this.props.courierOptions }
              handleSubmit={ this.handleSubmit }

              orderIds={ids}
              courierId={courier_id}
              loading={loading}
              orders={orders}
              errors ={errors}
            />
            <div>
              { showToast ?
                <Toast
                  content={toastContent}
                  onDismiss={this.closeToast} />
                : null
              }
            </div>
          </Page>
        </Frame>
      </AppProvider>
    )
  }
}

export default DispatchControlFormWrapper;
